import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEditBig: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"edit-big, box, pencil, pen, write, draw"} maskId="square-filled-radius-0-stroke-1-IconEditBig"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H12V4H4V20H20V12H21V21H3V3Z" fill="currentColor"/><path d="M21.9571 5.75008L18.25 2.04297L7 13.293V17.0001H10.7071L21.9571 5.75008Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconEditBig;
